function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import values from 'ramda/src/values';
import ApiConstants from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
export var UPDATE_MOBILE_NUMBER_PORTABILITY_ADDRESS_MODEL = 'UPDATE_MOBILE_NUMBER_PORTABILITY_ADDRESS_MODEL';
export var updateMobileNumberPortabilityAddressModel = function updateMobileNumberPortabilityAddressModel(formModel) {
  return {
    type: UPDATE_MOBILE_NUMBER_PORTABILITY_ADDRESS_MODEL,
    payload: formModel
  };
};
export var UPDATE_MOBILE_NUMBER_PORTABILITY_MODEL = 'UPDATE_MOBILE_NUMBER_PORTABILITY_MODEL';
export var updateMobileNumberPortabilityModel = function updateMobileNumberPortabilityModel(formModel) {
  return {
    type: UPDATE_MOBILE_NUMBER_PORTABILITY_MODEL,
    payload: formModel
  };
};
export var RESET_MOBILE_NUMBER_PORTABILITY_MODELS = 'RESET_MOBILE_NUMBER_PORTABILITY_MODELS';
export var resetMobileNumberPortabilityModels = function resetMobileNumberPortabilityModels() {
  return {
    type: RESET_MOBILE_NUMBER_PORTABILITY_MODELS
  };
};
export var RESET_PORTABILITY_MODEL = 'RESET_PORTABILITY_MODEL';
export var resetPortabilityModel = function resetPortabilityModel() {
  return {
    type: RESET_PORTABILITY_MODEL
  };
};
export var SAVE_PORTABILITY_ATTRIBUTE = 'SAVE_PORTABILITY_ATTRIBUTE';
export var saveMobileNumberPortabilityAttribute = function saveMobileNumberPortabilityAttribute(attributeId) {
  return {
    type: SAVE_PORTABILITY_ATTRIBUTE,
    payload: {
      attributeId: attributeId
    }
  };
};
export var RESTORE_PORTABILITY_ATTRIBUTE = 'RESTORE_PORTABILITY_ATTRIBUTE';
export var restoreMobileNumberPortabilityAttribute = function restoreMobileNumberPortabilityAttribute(attributeId) {
  return {
    type: RESTORE_PORTABILITY_ATTRIBUTE,
    payload: attributeId
  };
};
export var SET_SHOW_PORTABILITY = 'SET_SHOW_PORTABILITY';
export var setShowPortability = function setShowPortability(showPortability) {
  return {
    type: SET_SHOW_PORTABILITY,
    payload: showPortability
  };
};
export var MOBILE_NUMBER_PORTABILITY_FORM_VALIDATED = 'MOBILE_NUMBER_PORTABILITY_FORM_VALIDATED';
export var formValidated = function formValidated() {
  return {
    type: MOBILE_NUMBER_PORTABILITY_FORM_VALIDATED
  };
};
export var VALIDATE_PORT_IN_DATA = {
  BEGIN: 'VALIDATE_PORT_IN_DATA_BEGIN',
  SUCCESS: 'VALIDATE_PORT_IN_DATA_SUCCESS',
  FAILURE: 'VALIDATE_PORT_IN_DATA_FAILURE'
};
export var VALIDATE_PORT_IN_DATA_TYPES = [VALIDATE_PORT_IN_DATA.BEGIN, VALIDATE_PORT_IN_DATA.SUCCESS, VALIDATE_PORT_IN_DATA.FAILURE];
export var validatePortInDataPromise = function validatePortInDataPromise(dispatch, addressData, portabilityData, inventoryTypeId, customerId) {
  return ThunkHelper(dispatch, VALIDATE_PORT_IN_DATA_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/ValidatePortInData',
    data: {
      PortInData: {
        AdditionalProperties: portabilityData.mnpAdditionalProps,
        Address: addressData,
        ServiceProviderId: portabilityData.provider,
        InventoryTypeId: inventoryTypeId,
        PortInNumber: portabilityData.existingNumber,
        ValidationToken: null
      }
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var validatePortInData = function validatePortInData(addressData, portabilityData, inventoryTypeId, customerId) {
  return function (dispatch) {
    return validatePortInDataPromise(dispatch, addressData, portabilityData, inventoryTypeId, customerId);
  };
};
export var MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY = 'MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY';
export var mobileNumberPortabilitySetEditAdditionalProperty = function mobileNumberPortabilitySetEditAdditionalProperty(AdditionalProperties) {
  return {
    type: MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY,
    payload: AdditionalProperties
  };
};
export var MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY_ON_CHANGE = 'MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY_ON_CHANGE';
export var mobileNumberPortabilitySetEditAdditionalPropertyOnChange = function mobileNumberPortabilitySetEditAdditionalPropertyOnChange(id, newValue) {
  return {
    type: MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY_ON_CHANGE,
    payload: {
      id: id,
      newValue: newValue
    }
  };
};
export var UPDATE_PORT_IN_DATA = {
  BEGIN: 'UPDATE_PORT_IN_DATA_BEGIN',
  SUCCESS: 'UPDATE_PORT_IN_DATA_SUCCESS',
  FAILURE: 'UPDATE_PORT_IN_DATA_FAILURE'
};
export var updatePortInDetails = function updatePortInDetails(_ref) {
  var customerId = _ref.customerId,
    caseId = _ref.caseId,
    portabilityData = _ref.portabilityData,
    address = _ref.address,
    inventoryTypeId = _ref.inventoryTypeId,
    validationToken = _ref.validationToken;
  return function (dispatch) {
    return ThunkHelper(dispatch, values(UPDATE_PORT_IN_DATA), {
      method: 'post',
      url: 'SubscriberManagement/UpdatePortInDetails',
      data: {
        CaseId: caseId,
        PortInData: {
          AdditionalProperties: portabilityData.mnpAdditionalProps,
          Address: address,
          ServiceProviderId: portabilityData.provider,
          InventoryTypeId: inventoryTypeId,
          PortInNumber: portabilityData.existingNumber,
          ValidationToken: validationToken
        }
      },
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
    });
  };
};